<template>
  <div class="domain-search"
       :class="{'is-fixed':isFixed}">
    <div class="container clearfix">
      <div class="search clearfix">
        <div class="top clearfix">
          <span class="fl f16"
                v-if="layout.indexOf('ad1')!==-1">企业经营互联网，第一步从域名开始</span>
          <span class="fr f12"
                v-if="layout.indexOf('ad2')!==-1">新用户福利:注册领取789元大礼包，.com25元/首年，.xyz0元/首年</span>
        </div>
        <input type="text"
               v-model="domainName"
               placeholder="注册域名请先查询，例如输入：300"
               @keydown.enter="query">
        <input type="button"
               value="查询域名"
               class="query-button"
               @click="query">
        <div class="cart-button">
          购物车
          <span class="badge">{{$parent.cartList&&$parent.cartList.length}}</span>
          <slot></slot>
        </div>
        <div class="bottom clearfix"
             v-if="layout.indexOf('ad3')!==-1">
          <a href="/domain/info-intro/en/cn"
             class="price">.cn
            <em>¥35</em>
          </a>
          <a href="/domain/info-intro/en/com"
             class="price">.com
            <em>¥58</em>
          </a>
          <a href="/domain/info-intro/en/net"
             class="price">.net
            <em>¥80</em>
          </a>
          <a href="/domain/info-intro/cn/网址"
             class="price">.网址
            <em>¥1400</em>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import suffix1 from '../../static/assets/suffix1'
import suffix2 from '../../static/assets/suffix2'
import suffix3 from '../../static/assets/suffix3'
import prohibitionsWordList from "../../static/assets/prohibitionsWordList";
export default {
  props: {
    layout: {
      default: ''
    },
    isFixed: {
      default: false
    }
  },
  data () {
    return {
      domainName: this.$route.query.domainName,
      domainSuffix: '',
      wordFlag: false
    }
  },
  computed: {
    language () {
      return /[\u4e00-\u9fa5]/g.test(this.domainName) ? 'cn' : 'en'
    }
  },
  methods: {
    query () {
      this.wordFlag = false;
      const reg = new RegExp(
        '^[A-Za-z０１２３４５６７８９－0-9-Ａ-Ｚａ-ｚ\u4e00-\u9fa5]+$'
      )
      this.domainName = this.domainName.trim()
      // 如果不输入，不执行操作
      if (!this.domainName) return

      // 完整域名拆分处理
      const index = this.domainName.indexOf('.')
      if (index !== -1) {
        this.domainSuffix = this.domainName.substr(index)
        this.domainName = this.domainName.substr(0, index)
      }

      // 如果用户输入的域名后缀不在后缀列表，重置为.com
      if (
        this.domainSuffix &&
        suffix1.indexOf(this.domainSuffix) === -1 &&
        suffix2.indexOf(this.domainSuffix) === -1 &&
        suffix3.indexOf(this.domainSuffix) === -1
      ) {
        this.domainSuffix = ''
      }
      // 违禁词
      prohibitionsWordList.map(v => {
        if (this.domainName.indexOf(v) !== -1) {
          this.wordFlag = true;
        }
      });
      
      if (this.wordFlag) {
        this.$msgbox({
          type: "error",
          message: "该域名限制注册！"
        });
        return;
      }
      if (this.domainName.length > 63) {
        this.$msgbox({
          type: 'error',
          message: '域名长度超出最大限制！'
        })
        return
      }

      if (!reg.test(this.domainName)) {
        if (this.language === 'cn') {
          this.$msgbox({
            title: '您输入的域名不符合注册规则，请重新输入',
            type: 'error',
            message:
              '提示：中文域名至少需要含有一个中文文字，可以包含中文、字母a-z(大小写等价)、数字0-9或者半角的连接符“-”，“-”不能放在开头或者结尾，输入内容不能超过63个字符，最多可以注册19个汉字。'
          })
        } else {
          this.$msgbox({
            title: '您输入的域名不符合注册规则，请重新输入',
            type: 'error',
            message:
              '提示：域名可由英文字母（a-z,不区分大小写）、数字（0-9）、连字符“-”（即中横线）,不能使用空格及特殊字符（如！、$、&、？等），“-”不能单独填写或连续使用，不能放在开头或结尾，输入内容不能超过63个字符。'
          })
        }

        return
      }
      sensors.track("click_search_index", {
        commodity_search_type:'域名',
        commodity_search_wd: this.domainName.toLowerCase(),
        commodity_search_place: "详情页",
      });
      this.$emit('query', {
        domainName: this.domainName.toLowerCase(),
        domainSuffix: this.domainSuffix
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import "../../static/css/mixin.scss";

// 域名搜索框
.domain-search {
  width: 100%;
  height: 150px;
  background-color: #1fb09f;
  z-index: 2001;
  .search {
    position: relative;
    margin: 48px auto 0;
    width: 1118px;
    .top {
      color: #fff;
      position: absolute;
      height: 20px;
      line-height: 20px;
      vertical-align: bottom;
      top: -24px;
      width: 100%;
    }

    .bottom {
      font-size: 14px;
      line-height: 14px;
      position: absolute;
      bottom: -33px;

      .price {
        text-align: center;
        width: 110px;
        float: left;
        font-size: 14px;
        color: #fff;
        border-left: 1px solid #04665b;
      }

      .price:first-of-type {
        border: none;
        text-align: left;
        width: 80px;
      }

      em {
        font-style: normal;
        color: #fcff00;
      }
    }
    input[type="text"] {
      // width: 724px;
      width: 906px;
      height: 53px;
      border: none;
      outline: none;
      font-size: 12px;
      line-height: 53px;
      padding: 0 20px;
      float: left;
      transition: width 0.3s;
    }
    .query-button {
      @include fixed-button(172px, 53px, #038576, #fff, 18px);
      float: left;
    }
    .cart-button {
      @include fixed-button(172px, 53px, #ffba00, #fff, 18px);
      display: none;
      float: left;
      padding-left: 32px;
      margin-left: 10px;
      margin-right: -182px;
      background-image: url(../../static/assets/shopcarbtn.png);
      background-repeat: no-repeat;
      background-position: 28px 12px;
      position: relative;

      .badge {
        @include fixed-button(22px, 22px, #ff0000, #fff, 14px);
        border-radius: 11px;
        float: right;
        margin-right: 10px;
        margin-top: 15px;
      }
    }
  }
}

.domain-search.is-fixed {
  position: fixed;
  .search {
    input[type="text"] {
      width: 724px;
    }
    .cart-button {
      display: block;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/domain-search.vue